// ==== CORE ==== //

// A simple wrapper for all your custom jQuery; everything in this file will be run on every page
;(function($){
	$(function(){
		clickFlag = true;
		$slides = [];
		slideCaptions = [];
		prevBtnSlides = [];
		nextBtnSlides = [];
		i = 0;
		// function resetInterval() {
		//      clearInterval(autoplay);
		//      autoplay = setInterval(function(){ 
		//      	changeSlide('next'); }, 5000);
		//  };

		$(window).load(function() {

			// Mappo lo slider
			$('.slide').each(function(i, item) {
				$slides.push($(item));
			});

			changeSlide();

			// autoplay = setInterval( function(){ 
			// 			changeSlide('next'); 
			// 		}, 5000);

		});


		function _resetPrevSlide() {
			if (i == 0) {
				$slides[$slides.length - 1].removeClass('prev');
			} else {
				$slides[i-1].removeClass('prev');
			}
		}

		function _resetNextSlide() {
			if (i == $slides.length - 1) {
				$slides[0].removeClass('next');
			} else {
				$slides[i+1].removeClass('next');
			}
		}

		function _setPrevSlide() {
			if (i == 0) {
				$slides[$slides.length - 1].addClass('prev');
			} else {
				$slides[i-1].addClass('prev');
			}
		}

		function _setNextSlide() {
			if (i == $slides.length - 1) {
				$slides[0].addClass('next');
			} else {
				$slides[i+1].addClass('next');
			}
		}

		function _nextIndex() {
			if (i == $slides.length -1) {
				i = 0;
			} else {
				i++;
			}
		}

		function _prevIndex() {
			if (i == 0) {
				i = $slides.length -1;
			} else {
				i--;
			}
		}

		function _setPrevButton() {
			
			$('.prevBtn .btnSlide.btnSlide--prev').removeClass('btnSlide--prev');
			$('.prevBtn .btnSlide.btnSlide--active').removeClass('btnSlide--active');

			if (i == 0) {
				$('.prevBtn .btnSlide:eq(' + ($slides.length-1) + ')')
					.removeClass('btnSlide--prev btnSlide--next')
					.addClass('btnSlide--active');
				if ( $slides.length >= 3 ) {
					$('.prevBtn .btnSlide.btnSlide--prev').removeClass('btnSlide--prev');
					$('.prevBtn .btnSlide:eq(' + ($slides.length-2) + ')').addClass('btnSlide--prev');
				}

				$('.prevBtn .btnSlide.btnSlide--next').removeClass('btnSlide--next');
				$('.prevBtn .btnSlide:eq(' + i + ')').addClass('btnSlide--next');
			} else if (i == 1) {

				$('.prevBtn .btnSlide:eq(' + 0 + ')')
					.removeClass('btnSlide--prev btnSlide--next')
					.addClass('btnSlide--active');
					
				$('.prevBtn .btnSlide.btnSlide--prev').removeClass('btnSlide--prev');
				$('.prevBtn .btnSlide:eq(' + ($slides.length-1) + ')').addClass('btnSlide--prev');

				$('.prevBtn .btnSlide.btnSlide--next').removeClass('btnSlide--next');
				$('.prevBtn .btnSlide:eq(' + i + ')').addClass('btnSlide--next');

			} else {

				$('.prevBtn .btnSlide:eq(' + (i-1) + ')')
					.removeClass('btnSlide--prev btnSlide--next')
					.addClass('btnSlide--active');

				$('.prevBtn .btnSlide.btnSlide--next').removeClass('btnSlide--next');
				$('.prevBtn .btnSlide:eq(' + i + ')').addClass('btnSlide--next');

				$('.prevBtn .btnSlide.btnSlide--prev').removeClass('btnSlide--prev');
				$('.prevBtn .btnSlide:eq(' + (i-2) + ')').addClass('btnSlide--prev');
			}
		}


		function _setNextButton() {
		
			$('.nextBtn .btnSlide.btnSlide--prev').removeClass('btnSlide--prev');
			$('.nextBtn .btnSlide.btnSlide--active').removeClass('btnSlide--active');
			if (i >= $slides.length -1) {
				$('.nextBtn .btnSlide:eq(' + 0 + ')')
					.removeClass('btnSlide--prev btnSlide--next')
					.addClass('btnSlide--active');

				$('.nextBtn .btnSlide.btnSlide--prev').removeClass('btnSlide--prev');
				$('.nextBtn .btnSlide:eq(' + i + ')').addClass('btnSlide--prev');

				$('.nextBtn .btnSlide.btnSlide--next').removeClass('btnSlide--next');
				$('.nextBtn .btnSlide:eq(' + 1 + ')').addClass('btnSlide--next');
							

			} else if ( i >= $slides.length -2) {
				$('.nextBtn .btnSlide:eq(' + ($slides.length -1) + ')')
					.removeClass('btnSlide--prev btnSlide--next')
					.addClass('btnSlide--active');
				if ( $slides.length >= 3 ) {
					$('.nextBtn .btnSlide.btnSlide--prev').removeClass('btnSlide--prev');
					$('.nextBtn .btnSlide:eq(' + (i) + ')').addClass('btnSlide--prev');
				}

				$('.nextBtn .btnSlide.btnSlide--next').removeClass('btnSlide--next');
				$('.nextBtn .btnSlide:eq(' + (0) + ')').addClass('btnSlide--next');

			} else {

			$('.nextBtn .btnSlide:eq(' + (i+1) + ')')
				.removeClass('btnSlide--prev btnSlide--next')
				.addClass('btnSlide--active');
			if ( $slides.length >= 3 ) {
				$('.nextBtn .btnSlide.btnSlide--prev').removeClass('btnSlide--prev');
				$('.nextBtn .btnSlide:eq(' + (i) + ')').addClass('btnSlide--prev');
			}
			$('.nextBtn .btnSlide.btnSlide--next').removeClass('btnSlide--next');
			$('.nextBtn .btnSlide:eq(' + (i+2) + ')').addClass('btnSlide--next');
			}
		}



		function changeSlide(dir) {

			// Based on direction, go next or prev with the slide game
			if (dir == 'next') {

				_resetPrevSlide();
				$slides[i].removeClass('active').addClass('prev');
				_nextIndex();
				$slides[i].toggleClass('next active');

			} else if (dir == 'prev') {

				_resetNextSlide();
				$slides[i].removeClass('active').addClass('next');
				_prevIndex();
				$('.slide.prev').toggleClass('prev active');

			} else {
				$slides[i].addClass('active');
			}

			// Assign prev/next classes to slide
			_setPrevSlide();
			_setNextSlide();
			_setPrevButton(dir);
			_setNextButton(dir);
		}

	

	$('.nextBtn').on('click', function() {
		// resetInterval();
		if (clickFlag) {
			changeSlide('next');
		}	
		
	});


	$('.prevBtn').on('click', function() {
		// resetInterval();
		if (clickFlag) {
			changeSlide('prev');
		}
		
	});

});
}(jQuery));





